import { useEffect, useState } from 'react';
import axios from 'axios';
import Globais, { validateToken } from '../../../components/Globais';


export const useCategoriaMensagens = () => {
  const [categorias, setCategorias] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
 

  const fetchCategorias = async () => {
    const Token = validateToken();
    setIsLoading(true);
    if(!Token) return null;
    try {

        const URL = `${Globais.DOMINIOBACK}/categorias-mensagens`;
         const response = await axios.get(URL, {
              headers: {
                Authorization: Token.AuthStr,
              },
            });

        setCategorias(response.data);
      
      
      
    } catch (err) {
      console.error(err);
      setCategorias([]);
    }
    setIsLoading(false);
  };

  useEffect(() => {
      
    fetchCategorias();
  }, []);

  return { categorias, isLoading, fetchCategorias };
};
